import React from 'react';
import classNames from 'classnames';

const Badge = ({ dark, className, children, onClick, larger, rounded }) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
  <span
    onClick={onClick}
    className={classNames(
      'Badge',
      dark && 'Badge--dark',
      larger && 'Badge--larger',
      rounded && 'Badge--rounded',
      className,
    )}
  >
    {children}
  </span>
);

export default Badge;
